import React, { useEffect, useState, Fragment } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Form, Button } from "react-bootstrap";
import { API_URL } from "../../../config";
import { useSelector, useDispatch } from "react-redux";
import { setCourses } from "../../../store/actions/CourseAction";
import { logout } from "../../../store/actions/AuthActions";

const AddStudent = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const courses = useSelector((state) => state.courses.courses);
  const collegeId = useSelector((state) => state.college_id.college_id);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [masterCourseId, setMasterCourseId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [specId, setSpecId] = useState(null);
  const [passoutYearForm, setPassoutYearForm] = useState("");
  const [interestedPlacement, setInterestedPlacement] = useState(1);
  const [interestedHigherStudy, setInterestedHigherStudy] = useState(1);
  const [specializationData, setSpecializationData] = useState([]);
  const [course, setCourse] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const currentYear = new Date().getFullYear();

  // Load stored courses from localStorage into Redux
  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCourses(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  // Fetch the college's course list
  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    axios
      .get(`${API_URL}/api/freshment_portal_apis/GenericAPI/get_courses_list`, {
        params: { college_id: collegeId },
        headers: { Authorization: authToken },
      })
      .then((response) => {
        setCourse(response.data.data);
      })
      .catch((err) => {
        if (err?.response?.status === 401) dispatch(logout());
        console.log("err======", err);
      });
  }, []);

  // Resolve master course id → college course id for specialization lookup
  useEffect(() => {
    if (masterCourseId !== null) {
      const coursemaster = courses?.find(
        (c) => c.course_master_id == masterCourseId,
      );
      if (coursemaster) setCourseId(coursemaster.college_course_id);
    }
  }, [masterCourseId, courses]);

  // Fetch specializations when courseId changes
  useEffect(() => {
    if (courseId != null) {
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      axios
        .get(
          `${API_URL}/api/freshment_portal_apis/GenericAPI/get_course_spealization_list`,
          {
            params: { college_id: collegeId, course_id: courseId },
            headers: { Authorization: authToken },
          },
        )
        .then((response) => {
          setSpecializationData(response.data.data);
        })
        .catch((err) => {
          if (err?.response?.status === 401) dispatch(logout());
          console.log("err======", err);
        });
    }
  }, [courseId]);

  const handleSubmit = () => {
    if (!fullName || fullName.trim() === "") {
      toast.error("Full name is required.");
      return;
    }
    if (!email || email.trim() === "") {
      toast.error("Email address is required.");
      return;
    }
    if (!phoneNumber || phoneNumber.trim() === "") {
      toast.error("Phone number is required.");
      return;
    }
    if (!masterCourseId) {
      toast.error("Please select a course.");
      return;
    }
    if (!passoutYearForm) {
      toast.error("Please select your graduation year.");
      return;
    }
    if (!collegeId) {
      toast.error("Please select your college.");
      return;
    }

    const params = new URLSearchParams();
    params.append("college_connect_id", collegeId);
    params.append("full_name", fullName);
    params.append("email", email);
    params.append("phone_number", phoneNumber);
    params.append("course_id", masterCourseId);
    params.append("passout_year", passoutYearForm);
    if (specId !== null && specId !== "") {
      params.append("specialization_id", specId);
    }
    params.append("interested_in_placement", interestedPlacement);
    params.append("interested_in_higher_education", interestedHigherStudy);

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    setIsSubmitting(true);
    axios
      .post(
        `${API_URL}/api/freshment_portal_apis/Students/add_student_details`,
        params,
        { headers: { Authorization: authToken } },
      )
      .then((response) => {
        if (response.data.success) {
          toast.success("Student added successfully!");
          history.push("/invite-student");
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) dispatch(logout());
        toast.error("Failed to add student.");
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <Fragment>
      {/* Page Header */}

      <div className="d-flex align-items-center mb-4">
        <Button
          variant="primary"
          size="sm"
          onClick={() => history.push("/invite-student")}
        >
          <i className="fa fa-arrow-left"></i> Back
        </Button>
        <h4 className="fs-22 font-w600 mb-0 flex-grow-1 text-center">
          Add New Student
        </h4>
        <div style={{ width: "60px" }} />
      </div>

      {/* Form Card */}
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title mb-0">Student Information</h5>
          </div>
          <div className="card-body">
            <Form>
              {/* Full Name */}
              <Form.Group controlId="formFullName" className="mb-3">
                <Form.Label>
                  Full Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter full name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Email */}
              <Form.Group controlId="formEmail" className="mb-3">
                <Form.Label>
                  Email <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Phone Number */}
              <Form.Group controlId="formPhoneNumber" className="mb-3">
                <Form.Label>
                  Phone Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </Form.Group>

              {/* Select Course */}
              <Form.Group className="mb-3">
                <Form.Label>
                  Select Course <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  value={masterCourseId || "Select Course"}
                  onChange={(e) => {
                    if (e.target.value === "Select Course") {
                      setMasterCourseId(null);
                      setSpecId(null);
                      setSpecializationData([]);
                    } else {
                      setMasterCourseId(e.target.value);
                      setSpecId(null);
                      setSpecializationData([]);
                    }
                  }}
                  id="courseSelect"
                >
                  <option value="Select Course">Select Course</option>
                  {course?.map((c) => (
                    <option key={c.course_master_id} value={c.course_master_id}>
                      {c.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              {/* Select Specialization */}
              <Form.Group className="mb-3">
                <Form.Label>Select Specialization</Form.Label>
                <Form.Control
                  as="select"
                  value={specId || "Select Specialization"}
                  onChange={(e) => {
                    if (e.target.value === "Select Specialization") {
                      setSpecId(null);
                    } else {
                      setSpecId(e.target.value);
                    }
                  }}
                  id="branchSelect"
                >
                  <option value="Select Specialization">
                    Select Specialization
                  </option>
                  {specializationData &&
                    specializationData.length > 0 &&
                    specializationData.map((specialize) => (
                      <option
                        key={specialize.specilization_master_id}
                        value={specialize.specilization_master_id}
                      >
                        {specialize.name}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>

              {/* Select Passout Year */}
              <Form.Group className="mb-3">
                <Form.Label>
                  Select Passout Year <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  value={passoutYearForm}
                  onChange={(e) => setPassoutYearForm(e.target.value)}
                  id="passoutYearSelect"
                >
                  <option value="">Select Year</option>
                  <option value={currentYear - 1}>{currentYear - 1}</option>
                  <option value={currentYear}>{currentYear}</option>
                  <option value={currentYear + 1}>{currentYear + 1}</option>
                  <option value={currentYear + 2}>{currentYear + 2}</option>
                </Form.Control>
              </Form.Group>

              {/* Interested In College Placement */}
              <Form.Group controlId="IntrestedPlacement" className="mb-3">
                <Form.Label>Interested In College Placement</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="radio"
                    label="Yes"
                    value="1"
                    name="interestedPlacement"
                    onChange={() => setInterestedPlacement(1)}
                    checked={interestedPlacement === 1}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="No"
                    value="0"
                    name="interestedPlacement"
                    onChange={() => setInterestedPlacement(0)}
                    checked={interestedPlacement === 0}
                  />
                </div>
              </Form.Group>

              {/* Interested In Higher Studies */}
              <Form.Group controlId="intrestedHigherStudies" className="mb-4">
                <Form.Label>Interested In Higher Studies</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="radio"
                    label="Yes"
                    value="1"
                    name="interestedHigherStudy"
                    onChange={() => setInterestedHigherStudy(1)}
                    checked={interestedHigherStudy === 1}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="No"
                    value="0"
                    name="interestedHigherStudy"
                    onChange={() => setInterestedHigherStudy(0)}
                    checked={interestedHigherStudy === 0}
                  />
                </div>
              </Form.Group>

              {/* Action Buttons */}
              <div className="d-flex gap-3">
                <Button
                  variant="danger btn-sm"
                  onClick={() => history.push("/invite-student")}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary btn-sm"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Save Student"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddStudent;
